import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageSelectorComponent } from './page-selector/page-selector.component';

const routes: Routes = [
  { path: 'login', loadChildren: () => import('./login/login-module').then((m) => m.LoginModule) },
  { path: 'admin', loadChildren: () => import('./admin/admin-module').then((m) => m.AdminModule) },
  { path: '**', component: PageSelectorComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
